const observeDOM = (function() {
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function(obj, callback) {
    if(!obj || obj.nodeType !== 1) return; 

    if(MutationObserver) {
      const mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(obj, { childList:true, subtree:true });
      return mutationObserver;
    } else if(window.addEventListener) {
      obj.addEventListener('DOMNodeInserted', callback, false)
      obj.addEventListener('DOMNodeRemoved', callback, false)
    }
  }
})()

/**
 *  @class
 *  @function СartProductionAttribute
 */
class СartProductionAttribute {
  constructor() {
    this.addCartNodeChangesObserving();
    this.addEvents();
    this.hideProductionProductsSomeElements();
  }
  
  get cartHeaders() {
    return {
      "Content-Type": "application/json",
      "Accept": "application/json"
    }
  }

  get productionVariantIds() {
    const productionItemEls = document.querySelectorAll('div.production-item');
    return Object.keys(Object.fromEntries(Array.from(productionItemEls).map(el => [el.dataset.variantid, 0]))).map(k => +k);
  }

  async getCartStateApi() {
    return await fetch("/cart", {
      method: "GET",
      headers: this.cartHeaders,
    }).then(cartResp => cartResp.json())
  }

  async updateCartStateApi(bodyObj) {
    return fetch("/cart/update", {
      method: "POST",
      headers: this.cartHeaders,
      body: JSON.stringify(bodyObj)
    })
    .then(updateResp => updateResp.json())
  }
  
  addCartNodeChangesObserving() {
    const cartEl = document.querySelector('#Cart');
    observeDOM(cartEl, (m) => { 
      this.addEvents();
      this.removeProductionProductsIfNeed();
      this.hideProductionProductsSomeElements();
    });
  
    const cartDrawerEl = document.querySelector('#Cart-Drawer');
    observeDOM(cartDrawerEl, (m) => { 
      this.addEvents();
      this.removeProductionProductsIfNeed();
      this.hideProductionProductsSomeElements();
    });
  }

  addEvents() {
    document.querySelectorAll('div.production-item').forEach(el => el.onclick = (e) => {
      e.preventDefault();
  
      const elVariantId = +el.dataset.variantid;
      const inputEl = el.querySelector('input.production-item-input');
  
      this.getCartStateApi().then(cartRespObj => {
        const inCart = !!cartRespObj.items.find(i => i.id == elVariantId);
        const updates = Object.fromEntries(this.productionVariantIds.map(variantId => [
          variantId,
          !inCart && variantId == elVariantId ? 1 : 0
        ]));
  
        this.updateCartStateApi({
          updates,
          attributes: { Production: !inCart ? inputEl.value : null },
          sections: ['main-cart','cart-drawer','cart-bubble']
        }).then(updateRespObj => this.renderCartByQueryResponse(updateRespObj))
      })
    })
  }

  removeProductionProductsIfNeed() {
    this.getCartStateApi().then(cartRespObj => {
      const onlyProductionsLeft = cartRespObj.items.length > 0 && cartRespObj.items.every(i => this.productionVariantIds.includes(i.id));
      if (!onlyProductionsLeft) return;

      this.updateCartStateApi({
        updates: Object.fromEntries(this.productionVariantIds.map(variantId => [ variantId, 0 ])),
        attributes: { Production: null },
        sections: ['main-cart','cart-drawer','cart-bubble']
      }).then(updateRespObj => this.renderCartByQueryResponse(updateRespObj))
    })
  }
  
  hideProductionProductsSomeElements() {
    const removeEls = (parentEl) => {
        const qElMain = parentEl.querySelector('.product-quantity');
        const rElMobile = parentEl.querySelector('.remove');
        const qElMobile = parentEl.querySelector('quantity-selector.quantity');
        const optionEls = parentEl.querySelectorAll('.product-cart-item-options');
        const linkEl = parentEl.querySelector('.cart-product-link');
      
        if (linkEl) {
          linkEl.href = "javascript:void(0);";
          linkEl.style.cursor = 'default';
        }
        if (qElMain) qElMain.innerHTML = '';
        if (rElMobile) rElMobile.style.display = 'none';
        if (qElMobile) qElMobile.style.display = 'none';
        if (optionEls) optionEls.forEach(el => el.innerHTML = '');
    }
    
    this.productionVariantIds.forEach(p => {
      const elMain = document.querySelector('tr[data-product-id^="'+p+'"]');
      if (elMain) removeEls(elMain);
      
      const cartDrawerEl = document.querySelector('div#Cart-Drawer');
      if (cartDrawerEl) {
        const qElDraw = cartDrawerEl.querySelector('quantity-selector[data-id^="'+p+'"]');
        if (qElDraw) {
          const elDraw = qElDraw.closest('.product-cart-item');
          if (elDraw) removeEls(elDraw);
        }
      }
    })
  }

  renderCartByQueryResponse(responseObj) {
    //rendering main Cart
    if (typeof Cart !== 'undefined') new Cart().renderContents(responseObj);

    //rendering main CartDrawer
    const cd = new CartDrawer();
    cd.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      if (responseObj.sections) {
        elementToReplace.innerHTML = cd.getSectionInnerHTML(responseObj.sections[section.section], section.selector);
      }
    }));

    cd.removeProductEvent();
    cd.notesToggle();
    cd.termsCheckbox();
    cd.updateFreeShipping();
  }
}

window.addEventListener('load', () => {
  if (typeof СartProductionAttribute !== 'undefined') {
    window.cpa = new СartProductionAttribute();
  }
});